/**
 * @author wuTao
 * @description 单店报告导入
 * @Date 2023/05/30
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {WizTableForm} from '@/containers/common';

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})

let {WizTypography, WizModal, WizSpin, WizForm, WizCard, WizAntdForm, WizButton, Wizmessage,WizRow,WizCol} = component_tool;
let {WizContainer, WizFileUpload, modelUtils} = framework_tool;

const {Paragraph} = WizTypography;
const {Item} = WizAntdForm
let {Session} = utils_tool;

const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/storeReport/storeReportList/import') {
      if (history.location && history.location.record && history.location.record.id) {
        record = history.location.record
        Session.set('storeReportImportInfo', record);
      } else {
        record = Session.get('storeReportImportInfo') || {}
      }
    }
  }
  return record
}

class StoreReportFileImport extends WizContainer {

  componentName = 'storeReportFileImport';

  constructor(props) {
    super(props);
    const {history} = props;
    let record = getParamRecord(history)
    this.state = {
    }
    this.initialValue = record;
    this.itemCol = {
      wrapperCol: {
        xs: {span: 10, offset: 1},
        sm: {span: 10, offset: 1},
      },
      labelCol: {
        xs: {span: 12, offset: 0},
        sm: {span: 12, offset: 0},
      },
    }
  }

  _componentDidMount() {

  }

  _handleImport(nextProps, nextState) {
    let o = nextProps['storeReportImport']
    if (o['success']) {
      // let data = o['data'];
      // let str = data.replace(/<br\/>/g, "\n")
      // WizModal.success({
      //   title: '导入结果',
      //   content: <p style={{whiteSpace: "pre-line"}}>{str}</p>
      // })
      wizNotice.success(o['msg'])
      this.jumpPage('replace', '/storeReport/storeReportList');
      return true;
    } else {
      wizNotice.error(o.msg)
      return false;
    }
  }

  propsAndStateOnChange = {
    storeReportImport: this._handleImport.bind(this),
  }

  /**
   * 提交按钮
   */
  _submitBtn() {
    return (
      // <Item label={' '} colon={false} {...this.itemCol}>
      //   <WizButton type='primary' onClick={this._saveStoreReport.bind(this)}>上 传</WizButton>
      // </Item>
      <WizRow className='audit-submit-button-row'>
      <WizCol span={24}>
        <WizButton type='primary' onClick={this._saveStoreReport.bind(this)}>上 传</WizButton>
      </WizCol>
    </WizRow>
    )
  }

  /**保存数据 */
  _saveStoreReport() {
    this.formData.validateFields((err, values) => {
      if (!err) {
        let _values = this.fitterFieldsValue(values);
        this.doAction({
          path: 'storeReport/import',
          payload: {
            key: 'storeReportImport',
            apiParams: {..._values}
          }
        })
      }
    });

  }


  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'fileId') {
        if (value && value.length) {
          fitterValues[key] = value[0]['fileId'];
        } else {
          fitterValues[key] = '';
        }
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * 上传文件前的钩子：自定义校验
   */
  beforeUpload = (file, showMessage = true) => {
    const isLt20M = file.size / 1024 / 1024 < 20;
    if (!isLt20M && showMessage) {
      Wizmessage.error('文件不得超过20MB!');
    }
    return isLt20M;
  }

  _columns = (data) => {
    return [
      {
        title: "品牌",
        name: "brandId",
        formItem: {
          diy: WizTableForm,
          ...organizationConfig,
          rowTitle: 'name',
          rules: [{
            required: true,
            message: '请选择品牌',
          }],
          selectType: 'radio',
        },
      },
      {
        title: "类型",
        name: "importType",
        dict: [
          {code: 0, codeName: "销售"},
          {code: 1, codeName: "售后"},
        ],
        formItem: {
          type: "select",
          rules: [{
            required: true,
            message: '请选择导入类型',
          },
          ]
        }
      },
      {
        title: "上传文件",
        name: "fileId",
        dataIndex: "fileId",
        formItem: {
          accept: ".xlsx",
          max: 1,
          type: 'custom',
          render: (record, form) => {
            const {getFieldDecorator} = form;
            return (<>
                {
                  getFieldDecorator('fileId', {
                    initialValue: [],
                    rules: [{
                      required: true,
                      message: '请上传文件',
                    },
                    ]
                  })(
                    <WizFileUpload
                      accept={'.xlsx'}
                      listType={'text'}
                      limit={-1}
                      uploadType={'system'}
                      progress={{
                        strokeColor: {
                          '0%': '#108ee9',
                          '100%': '#87d068',
                        },
                        strokeWidth: 3,
                        format: percent => `${parseFloat(percent.toFixed(2))}%`,
                      }}
                      beforeUpload={this.beforeUpload}
                    />
                  )
                }
              </>
            )
          }
        },
      },
      {
        title: "使用模板类型",
        name: "templateType",
        dict: [
          {code: 1, codeName: "别克销售2023V1"},
          {code: 2, codeName: "别克售后2023V1"},
          {code: 3, codeName: "雪佛兰销售2023V1"},
          {code: 4, codeName: "雪佛兰售后2023V1"},
          {code: 5, codeName: "凯迪拉克销售2023V1"},
          {code: 6, codeName: "凯迪拉克售后2023V1"},
        ],
        formItem: {
          type: "select",
          rules: [{
            required: true,
            message: '请选择使用模板类型',
          },
          ]
        }
      },
    ]
  }

  _render() {
    let formProps = {
      ref: 'formData',
      columns: this._columns({}),
      record: null,
      preview: null,
      footer: [],
      formItemLayout: {
        labelCol: {span: 5},
        wrapperCol: {span: 15}
      }
    }
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、按照要求格式填写信息</Paragraph>,
        <Paragraph>2、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '单店报告导入',
      template: null,
      upload: {}
    }
    let {storeReportLoading} = this.props;
    return (
      <WizSpin tip={'上传文件中'} spinning={storeReportLoading}>
        <WizCard title={infoProps.title} icon='0'> {infoProps.text}</WizCard>
        <WizCard title={operateProps.title} icon='0'>
          <WizForm className={'form-inline'} {...formProps}
                   ref={r => {
                     this.formData = r
                   }}/>
          {this._submitBtn()}
        </WizCard>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {storeReport} = state;
  const storeReportImport = modelUtils.getModelEntity(storeReport, 'storeReportImport');

  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'storeReport')
  return {
    storeReportImport,
    ...load
  }
};

export default connect(mapStateToProps)(StoreReportFileImport);
